export enum RoutesPaths {
	LOGIN = '/login',
	REGISTER = '/register',
	INSTRUCTIONS = '/',
	DEMO_REPORT = '/demo-report/:hash',
	PURCHASED_RESULT = '/purchased/:hash',
	OTP = '/otp',
	RUNNING_TEST = '/running-test/:hash',
	PROFILE_EDIT = '/profile',
	REPORTS = '/reports',
	ASSESSMENT_PLANS = '/assessment-plans/:hash',
	AB_ASSESSMENT_PLANS = '/ab-assessment-plans/:hash',
	CHAT = '/chat',
	CHAT_DETAILS = '/chat/:hash',
	VECTOR_TEST = '/vector-test/',
	COURSES = '/courses',
	COURSES_DETAILS = '/courses/:id'
}
